import languageModel from "../../models/language.model";
import navigationModel from "../../models/navigation/navigation.model";
import UploadUserManualModel from "../../models/upload-uesr-manual/upload-user-manual.model";
import ViewBase from "../../views/view-base.view";

export default function DownloadManualButton() {
  ViewBase.call(this);

  const findManualFileID = (id) => navigationModel.activeMenuList.find(({ menuID }) => menuID === id).fileUserManual;

  const downloadUserManual = (fileID, menuName) => {
    return UploadUserManualModel.downloadUserManual(fileID, `${menuName.replaceAll(' ', '')}Manual`)
      .catch(error => {
        this.handleError(error);
      });
  }

  return {
    view: ({ attrs: { menu } }) => {
      let fileID = findManualFileID(menu.menuID);
      return fileID && m('.position-absolute.bottom-0.end-0',
        m('button.btn.btn-primary', {
          onclick: () => { downloadUserManual(fileID, menu.name) }
        },
          languageModel.getText('LT00008097', 'Download Manual'))
      )
    }
  }
}